import Link from 'components/shared/Link/Link';
import { TeaserLinkItemProps } from 'libs/contentful/props';
import { cn } from 'utils/styles';
import { TeaserLinkContent } from './BaseTeaserLinkCard';

export type CopyTeaserLinkProps = Omit<TeaserLinkItemProps, 'image'>;

const CopyTeaserLink = ({ linkText, url, internalPage, className }: CopyTeaserLinkProps) => {
  return (
    <div className={`${className} md:min-w-[200px] md:max-w-[320px] `}>
      <Link
        withCtaAnalytics
        href={url}
        internalPage={internalPage}
        className={cn(
          'font-sans font-semibold',
          'group rounded-full border-(--btn-outline-scroll) border-[1.5px]',
          'bg-transparent hover:text-current text-wrap',
          'w-full h-full py-2.5 px-4',
        )}>
        <TeaserLinkContent>{linkText}</TeaserLinkContent>
      </Link>
    </div>
  );
};

export default CopyTeaserLink;
